/* eslint-disable no-process-env */
import { config } from './index';

export function isDevEnv() {
  try {
    return config().APP_ENVIRONMENT === 'development';
  } catch {
    return !process.env.APP_ENVIRONMENT || process.env.APP_ENVIRONMENT === 'development';
  }
}

export function isSandboxEnv() {
  try {
    return config().APP_ENVIRONMENT === 'sandbox';
  } catch {
    return process.env.APP_ENVIRONMENT === 'sandbox';
  }
}

export function isProdEnv() {
  try {
    return config().APP_ENVIRONMENT === 'production';
  } catch {
    return process.env.APP_ENVIRONMENT === 'production';
  }
}

// TODO: Turn into feature flags or configuration driven for downstream functionality
export function isJnJEnvironment() {
  return config().CLIENT_J_MODE;
}

export function isLowerEnv() {
  return isDevEnv() || isSandboxEnv();
}

// TODO: Turn into feature flags or configuration driven for downstream functionality
export function isDemoEnv() {
  return config().DEMO_ENV;
}

export function isVeevaPlatform() {
  try {
    return config().APP_PLATFORM === 'veeva';
  } catch {
    return process.env.APP_PLATFORM === 'veeva';
  }
}